import React from 'react';
import { ScoreExplanations, FinancialScoreExplanations, BufferOverallExplanations } from '../types/riskMeterTypes';
import { getScoreColor, getBufferOverallColor } from '../utils/riskMeterColors';
import './RiskMeter.css';

const scoreCellStyle = {
    fontWeight: 'bold' as const,
    textAlign: 'center' as const
};

export default function RiskMeterLegend() {
    return (
        <div className="row">
            <div className="col-4">
                <h5 style={{ marginBottom: '15px' }}>Phase/Milestone Score</h5>
                <table className="table table-bordered table-sm risk-meter-table">
                    <thead>
                        <tr>
                            <th style={{ width: '60px', textAlign: 'center' }}>Score</th>
                            <th>Meaning (from projected end date)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ScoreExplanations.map((explanation, index) => (
                            <tr key={index}>
                                <td style={{ ...scoreCellStyle, backgroundColor: getScoreColor(explanation.score) }}>
                                    {explanation.score}
                                </td>
                                <td>{explanation.meaning}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p style={{ fontSize: '0.8em', color: '#666', marginTop: '4px' }}>
                    Note: The later boundary always moves to the next highest risk score.
                </p>
            </div>

            <div className="col-4">
                <h5 style={{ marginBottom: '15px' }}>Financial Score</h5>
                <table className="table table-bordered table-sm risk-meter-table">
                    <thead>
                        <tr>
                            <th style={{ width: '60px', textAlign: 'center' }}>Score</th>
                            <th>Ratio</th>
                            <th>Meaning</th>
                        </tr>
                    </thead>
                    <tbody>
                        {FinancialScoreExplanations.map((explanation, index) => (
                            <tr key={index}>
                                <td style={{ ...scoreCellStyle, backgroundColor: getBufferOverallColor(explanation.score) }}>
                                    {explanation.score}
                                </td>
                                <td>{explanation.ratio}</td>
                                <td>{explanation.meaning}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p style={{ fontSize: '0.8em', color: '#666', marginTop: '4px' }}>
                    Ratio is available funds divided by the project required budget.
                </p>
            </div>

            <div className="col-4">
                <h5 style={{ marginBottom: '15px' }}>Buffer &amp; Overall Score</h5>
                <table className="table table-bordered table-sm risk-meter-table">
                    <thead>
                        <tr>
                            <th style={{ width: '60px', textAlign: 'center' }}>Score</th>
                            <th>Buffer Meaning</th>
                            <th>Overall Meaning</th>
                        </tr>
                    </thead>
                    <tbody>
                        {BufferOverallExplanations.map((explanation, index) => (
                            <tr key={index}>
                                <td style={{ ...scoreCellStyle, backgroundColor: getBufferOverallColor(explanation.score) }}>
                                    {explanation.score}
                                </td>
                                <td>{explanation.buffer}</td>
                                <td>{explanation.overall}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
